// Social links
export const YOUTUBE_LINK = "https://www.youtube.com/channel/UCPDb9GIuw5Nmb5Hrv7djByw";
export const LINKEDIN_LINK = "https://www.linkedin.com/company/ekeng-cjsc/mycompany/";
export const FACEBOOK_LINK = "https://www.facebook.com/EkengCJSC/";

// statuses
export const STATUS_SUCCESS = "success";
export const STATUS_FAILED = "failed";
export const STAGE_PHONE = "phone";
export const STAGE_CODE = "code";
export const STAGE_QR = "qr";

export const STORAGE_KEY_ACCESS_TOKEN = "UserContext@AccessToken";
export const STORAGE_KEY_LOGGED_USER = "UserContext@LoggedUser";
// sessionStorage key — resets when the tab closes; also cleared on signOut so
// the next user (or the same user after a re-login) sees the banner again.
export const SESSION_KEY_NOTIFICATIONS_BANNER_DISMISSED = "NotificationsScreen@InfoBannerDismissed";
export const SIDE_BACK = "back";
export const SIDE_FRONT = "front";

// Notifications read filter
export const READ_FILTER_ALL = "all";
export const READ_FILTER_READ = "read";
export const READ_FILTER_UNREAD = "unread";

// Notifications table labels
export const NOTIFICATION_TABLE_LABELS = {
  DATE: "Ծանուցման ամսաթիվ",
  SENDER: "Ում կողմից",
  TITLE: "Վերնագիր",
  PREVIEW: "Բովանդակություն",
  STATUS: "Կարգավիճակ",
};

export const NOTIFICATION_STATUS_LABEL = {
  UNREAD: "ՉԿԱՐԴԱՑԱԾ",
  READ: "ԿԱՐԴԱՑԱԾ",
};
